import { getBooleanOperatorValuesForCollectionFilter } from '../../../services/filtering/collection-filter-mapping-service';

const packageMapper = (appliedFilter) => {
  const criteria = getBooleanOperatorValuesForCollectionFilter(appliedFilter);
  return {
    unnormalizableCollectionFilters: [
      {
        column: 'PackageTypeId',
        values: [appliedFilter.criterionArgumentValue],
        isIn: criteria.isIn,
        isNull: criteria.isNull,
      },
    ],
  };
};

export default packageMapper;
